import { Box, CircularProgress, Typography } from "@mui/material";

export default function FallbackInformation({ children, showLoading = false }) {
    return (
        <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: 2 }}>
            {showLoading && <CircularProgress size={32} color="secondary" />}
            <Typography variant="caption" sx={{ textAlign: 'center' }}>{children}</Typography>
        </Box>
    );
}